<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Crear Jugador" />

    <CreatePlayer />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue"; 
import CreatePlayer from "@/components/Pages/Admin/Players/view.vue";

export default defineComponent({
  name: "CreatePlayerPage",
  components: {
    PageTitle,
    CreatePlayer,
  },
});
</script>
